import * as actions from 'actions/header';
import {
  VIDEO_DOWNLOAD_CLICK,
  VIDEO_DOWNLOAD_COMPLETED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import DownloadProgressUtil from 'utilities/download-progress';
import { trackDownloadClick } from 'utilities/video-session/mediaAnalyticsEvent';

export function toggleDropdownCreator(name) {
  return (dispatch, getState) => {
    const { dropdown_menu_name } = getState().header;

    dispatch(actions.closeDropdowns());

    if (dropdown_menu_name !== name) {
      return dispatch(actions.showDropdown(name));
    }
  };
}
/** @type {typeof DownloadProgressUtil.prototype} */
let downloadManager;

export function startDownload({ url, name, opts }) {
  return (dispatch, getState) => {
    const { downloading_video } = getState().header;

    if (downloading_video) {
      return;
    }

    analytics.track(VIDEO_DOWNLOAD_CLICK, opts);

    const resetState = () => {
      dispatch(actions.resetDownloading());
    };

    const updateProgress = progress => {
      dispatch(actions.setDownloadingProgress(progress));
    };

    const onComplete = () => {
      resetState();
      trackDownloadClick(opts.video_id);
      analytics.track(VIDEO_DOWNLOAD_COMPLETED, opts);

      downloadManager.save();
    };

    downloadManager = new DownloadProgressUtil(
      updateProgress,
      onComplete,
      resetState
    );

    downloadManager.fetch(url, name);

    dispatch(actions.setDownloading(true));
  };
}

export function abortDownload() {
  return dispatch => {
    dispatch(actions.resetDownloading());

    if (!downloadManager) {
      return;
    }

    downloadManager.abort();
  };
}
